/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { imageGetImageMotou } from "../../funcs/imageGetImageMotou.js";
import { GetImageMotouRequest$zodSchema } from "../../models/getimagemotouop.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: GetImageMotouRequest$zodSchema,
};

export const tool$imageGetImageMotou: ToolDefinition<typeof args> = {
  name: "image-get-image-motou",
  description: `生成摸摸头GIF (QQ号)

想在线rua一下好友的头像吗？这个趣味接口可以满足你。

## 功能概述
此接口通过GET方法，专门用于通过QQ号生成摸摸头GIF。你只需要提供一个QQ号码，我们就会自动获取其公开头像，并制作成一个可爱的动图。

## 使用须知
- **响应格式**：接口成功时直接返回 \`image/gif\` 格式的二进制数据。
- **背景颜色**：你可以通过 \`bg_color\` 参数来控制GIF的背景。使用 \`transparent\` 选项可以让它更好地融入各种聊天背景中。`,
  scopes: ["read"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": true,
    "readOnlyHint": true,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await imageGetImageMotou(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
